import { useEffect } from "react";

import Form from "../components/form/Form";

const CategoryForm = ({
  data = null,
  additionalButtons = null,
  onSubmit,
  form,
  formDetails,
}) => {
  useEffect(() => {
    if (data) {
      Object.keys(data).forEach((i) => form.setValue(i, data[i]));
    } else {
      form.reset();
    }
  }, [data]);

  return (
    <Form
      formDetails={formDetails}
      form={form}
      onSubmit={() => onSubmit(form.getValues(), form.setError, form.reset)}
      additionalButtons={additionalButtons}
    />
  );
};

export default CategoryForm;
